// extracted by mini-css-extract-plugin
export var cardTitle = "_i8-1";
export var commentBubble = "_i8-e";
export var commentForm = "_i8-a";
export var commentInput = "_i8-b";
export var commentLabel = "_i8-d";
export var commentPrompt = "_i8-9";
export var csatCard = "_i8-0";
export var feedbackSection = "_i8-7";
export var starDisabled = "_i8-6";
export var starEmpty = "_i8-5";
export var starFilled = "_i8-4";
export var starWrapper = "_i8-3";
export var starsContainer = "_i8-2";
export var submittedComment = "_i8-c";
export var thankYouText = "_i8-8";